import { Component, OnInit } from '@angular/core';
import { WISHLISTVIEW } from 'src/app/config';
import { ApiService } from 'src/app/api.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-account-wishlist',
    templateUrl: './account-wishlist.component.html',
    styleUrls: ['./account-wishlist.component.css'],
    
})
export class AccountWishlistComponent implements OnInit {
  data:any;
  uid:any;
  value:any;
  results:any;
  baseurl:any;
  div:boolean;
  alert:boolean;
  message:any;
  loader:boolean;
  page:boolean;
    constructor(private api:ApiService,private router:Router) {
      this.view();
      this.value=localStorage.getItem('wish');
    }
    view()
    {

      this.api.Get(WISHLISTVIEW).then(data=>{
      console.log(data);
       this.page=true;
        this.loader=false;
        this.div=true;
        this.alert=false;
         this.baseurl=data['url']+"/";
         this.results=data['data'];
         this.results = this.results.reverse();
       }).catch(d=>{
        if( d.status == 503){
          this.api.onFail('Your session is expired please login again','Login');
          this.api.setGoto();
          this.api.setlogin(0);
          this.api.logout();
          setTimeout(() => {
          this.router.navigate(['/login']);
          },1000);
        } else{
        this.page=true;
        this.loader=false;
         this.alert=true;
         this.div=false;
         this.message=d.error.data;
         console.log(d);}
       });






    }
    deleteWishlist(pid)
    {
      this.loader=true;
      this.page=false;
        this.api.deleteWishlist(pid);
        this.page=true;
        this.loader=false;
    }
    addToCart(s)
    {
      this.api.addToCart(s);
    }
    go(value) {
      this.api.godetail(value);
    }
    checkProductInCart(pid)
    {
       let cart=this.api.getCart();
       console.log(cart);
       if(cart)
       {
               let result=cart.find(x => x.product_id == pid);

               if(result)
               {
                   return false;
              }
              else{
                return true;
              }
         }
         else{
           return true;
         }
    }


    ngOnInit() {
      this.loader=true;
      this.page=false;
      this.api.getWish.subscribe(data=>{
        this.view();
         console.log("getWishSubscribe"+data);
         })

    }


  }
